// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectBrandingRulesMessage } from '@shared/utils/DirectMessages/DirectMessagesImport';
import { FieldsFactory } from '../Factory/FieldsFactory';
import { MessageProcessorBase } from './MessageProcessorBase';
export class BrandingRulesMessageProcessor extends MessageProcessorBase {
    decode(fieldSet) {
        const message = new DirectBrandingRulesMessage();
        const groups = fieldSet.GetGroups(FieldsFactory.KEY_VALUE_GROUP);
        const len = groups.length;
        for (let i = 0; i < len; i++) {
            const ruleValue = groups[i].GetValue(FieldsFactory.FIELD_VALUE);
            const ruleName = groups[i].GetValue(FieldsFactory.FIELD_KEY);
            switch (ruleName) {
                case 'BRANDING_TOOLS': {
                    message.Tools = ruleValue;
                    break;
                }
                case 'BRANDING_COMPANY_NAME': {
                    message.CompanyName = ruleValue;
                    break;
                }
                case 'BRANDING_COMPANY_URL': {
                    message.CompanyURL = ruleValue;
                    break;
                }
                case 'BRANDING_BROKER_INFORMATION': {
                    message.BrokerInformation = ruleValue;
                    break;
                }
                case 'BRANDING_POWERED_BY_NAME': {
                    message.PoweredByName = ruleValue;
                    break;
                }
                case 'BRANDING_POWERED_BY_URL': {
                    message.PoweredByURL = ruleValue;
                    break;
                    /* edited in #125345: */
                }
                case 'BRANDING_DEMOREGISTRATION_URL':
                case 'BRANDING_LOGIN_URL': {
                    /* URLs of Login screen demoreg link 1(=left),2(=right) */
                    message.BrandingDemoregistrationURLs.push(ruleValue);
                    break;
                }
                case 'BRANDING_DEMOREGISTRATION_URL_NAME':
                case 'BRANDING_LOGIN_URL_NAME': {
                    /* labels' text of Login screen demoreg link 1(=left),2(=right)  */
                    let linkName = ruleValue;
                    if (ruleName === 'BRANDING_DEMOREGISTRATION_URL_NAME' && !linkName) {
                        linkName = 'Registration'; // #126100 #126101
                    }
                    message.BrandingDemoregistrationURLNames.push(linkName);
                    break;
                    /* Added in ancient times (B.C.): */
                }
                case 'BRANDING_FORGOTPWD_URL': {
                    message.BrandingForgotpwdURL = ruleValue;
                    break;
                }
                case 'BRANDING_VISIBLE_INSTRUMENT_LOGO': {
                    message.BrandingVisibleInstrumentLogo = ruleValue;
                    break;
                }
                case 'BRANDING_SERVER_URL': {
                    message.BrandingServerURL = ruleValue;
                    break;
                }
                case 'BRANDING_IP_SERVICE_URL': {
                    message.BrandingIpServicesURL = ruleValue;
                    break;
                    /* added in #115286 Web: */
                }
                case 'BRANDING_WEB_NAME': {
                    message.BrandingWebName = ruleValue;
                    break;
                }
                case 'BRANDING_WEB_LOGIN_BANNER': {
                    message.BrandingWebLoginBanner = ruleValue;
                    break;
                }
                case 'BRANDING_WEB_SPLASH_SCREEN': {
                    message.BrandingWebSplashScreen = ruleValue;
                    break;
                }
                case 'BRANDING_WEB_HEADER': {
                    message.BrandingWebHeader = ruleValue;
                    break;
                }
                case 'BRANDING_WEB_FAVICON': {
                    message.BrandingWebFavicon = ruleValue;
                    break;
                    /* FROM .Net Light Theme added in #126603 Web: */
                }
                case 'BRANDING_NET_RIBBONICON_LIGHT': {
                    message.BrandingWebHeaderLightTheme = ruleValue;
                    break;
                }
                case 'BRANDING_NET_LOGO_LIGHT': {
                    message.BrandingWebLoginBannerLightTheme = ruleValue;
                    break;
                    /* added in #119719 Web: */
                }
                case 'BRANDING_EXTERNAL_AUTHENTICATION': {
                    message.BrandingExternalAuthenticationType = ruleValue;
                    break;
                }
                case 'BRANDING_EXTERNAL_AUTHENTICATION_URL': {
                    message.BrandingExternalAuthenticationUrl = ruleValue;
                    break;
                }
                case 'BRANDING_EXTERNAL_AUTHENTICATION_WEB_CLIENTID': {
                    message.BrandingExternalAuthenticationWebClientId = ruleValue;
                    break;
                }
                case 'BRANDING_EXTERNAL_AUTHENTICATION_WEBMOBILE_CLIENTID': {
                    message.BrandingExternalAuthenticationWebMobileClientId = ruleValue;
                    break;
                }
                case 'BRANDING_EXTERNAL_AUTHENTICATION_LOGOUT_URL': {
                    message.BrandingExternalAuthenticationLogoutUrl = ruleValue;
                    break;
                }
                case 'BRANDING_ALLOW_PASSWORD_PREVIEW': {
                    message.BrandingAllowPasswordPreview = ruleValue;
                    break;
                }
                case 'BRANDING_ALLOW_SAVE_PASSWORD': {
                    message.BrandingAllowSavePassword = ruleValue;
                    break;
                }
                case 'BRANDING_LOGIN_PROMPT_TEXT': {
                    message.BrandingLoginPromptText = ruleValue;
                    break;
                }
                // #region #115286 Web Mobile:
                case 'BRANDING_MOBILE_ACTIVE_WEB_LOGIN_BANNER': {
                    message.BrandingWMLoginBanner = ruleValue;
                    break;
                }
                case 'BRANDING_MOBILE_WEB_ACTIVE_BACKGROUND_IMAGE': {
                    message.BrandingWMBackgroundImage = ruleValue;
                    break;
                }
                case 'BRANDING_MOBILE_ACTIVE_WEB_FAVICON': {
                    message.BrandingWMFavicon = ruleValue;
                    break;
                }
                // #region Investing:
                case 'BRANDING_CUSTOM_SCHEME_INVESTING_WEB': {
                    message.BrandingInvestingCustomScheme = ruleValue;
                    break;
                }
                case 'BRANDING_INVESTING_WEB_FAVICON': {
                    message.BrandingInvestingFavicon = ruleValue;
                    break;
                }
                case 'BRANDING_INVESTING_WEB_SPLASH_SCREEN': {
                    message.BrandingInvestingSplashScreen = ruleValue;
                    break;
                }
                case 'BRANDING_INVESTING_WEB_LOGIN_BANNER': {
                    message.BrandingInvestingLoginBanner = ruleValue;
                    break;
                }
                case 'BRANDING_INVESTING_WEB_HEADER': {
                    message.BrandingInvestingWebHeader = ruleValue;
                    break;
                    // #region Localizations:
                }
                case 'BRANDING_WEB_LANG_FILE': {
                    message.BrandingWebLangFiles = ruleValue;
                    break;
                }
                case 'BRANDING_WEB_CUSTOM_URL': {
                    message.BrandingWebCustomUrl = ruleValue;
                    break;
                }
                case 'BRANDING_TV_LOGO': {
                    message.BrandingTVLogo = ruleValue;
                    break;
                }
                case 'BRANDING_TV_FAVICON': {
                    message.BrandingTVFavicon = ruleValue;
                    break;
                }
                case 'BRANDING_TV_NAME': {
                    message.BrandingTVName = ruleValue;
                    break;
                }
                case 'BRANDING_WEBHOOK_URL':
                    message.BrandingWebhookURL = ruleValue;
                    break;
                case 'BRANDING_WEBHOOK_HELP_URL':
                    message.BrandingWebhookHelpURL = ruleValue;
                    break;
            }
        }
        return [message];
    }
}
